import type { CustomerEnrichmentPort } from '../domain/customer-enrichment'

const clearCustomerEnrichment = async (port: CustomerEnrichmentPort, customerId: string): Promise<void> => {
	await port.clear(customerId)
}

export { clearCustomerEnrichment }
